<div
  *ngIf="user?.email"
  class="gw-min-h-screen gw-flex gw-flex-col gw-bg-background-base"
>
  <div class="gw-flex gw-justify-end gw-p-medium">
    <app-language-selector></app-language-selector>
  </div>

  <div class="gw-flex gw-flex-1 gw-items-center gw-justify-center gw-p-medium">
    <div
      class="gw-w-full gw-max-w-[420px] gw-bg-background-elevation-2 gw-border gw-border-border-normal gw-rounded-2xl gw-shadow-lg gw-overflow-hidden gw-p-2x-large"
    >
      <h2 class="gw-text-lg gw-font-semibold gw-text-text-primary gw-mb-small">
        {{ 'features.signup.page.title' | translate }}
      </h2>
      <p class="gw-text-sm gw-text-text-secondary gw-mb-2x-large">
        {{ 'features.signup.page.description' | translate }}
      </p>

      <form
        [formGroup]="signupForm"
        (ngSubmit)="onSubmit()"
        class="gw-flex gw-flex-col gw-gap-2x-large"
      >
        <gatewee-input-v2
          id="signup-name"
          type="text"
          [form]="signupForm"
          controlName="name"
          [label]="'features.signup.form.labels.name' | translate"
          [placeholder]="'features.signup.form.placeholders.name' | translate"
          [required]="true"
        ></gatewee-input-v2>

        <gatewee-input-v2
          id="signup-email"
          type="email"
          [form]="signupForm"
          controlName="email"
          [label]="'features.signup.form.labels.email' | translate"
          [placeholder]="'features.signup.form.placeholders.email' | translate"
          [readonly]="true"
          [required]="true"
        ></gatewee-input-v2>

        <div class="gw-relative">
          <gatewee-input-v2
            id="signup-password"
            [type]="hide_show ? 'text' : 'password'"
            [form]="signupForm"
            controlName="password"
            [label]="'features.signup.form.labels.password' | translate"
            [placeholder]="
              'features.signup.form.placeholders.password' | translate
            "
            [required]="true"
          ></gatewee-input-v2>
          <button
            type="button"
            (click)="passwordHide()"
            class="gw-absolute gw-right-small gw-top-[38px] gw-flex gw-items-center gw-justify-center gw-w-9 gw-h-9 gw-rounded-lg gw-text-text-secondary hover:gw-bg-background-elevation-1 hover:gw-text-text-primary"
            [attr.aria-label]="hide_show ? 'Hide password' : 'Show password'"
          >
            <gatewee-icon
              [icon]="hide_show ? '@phi.eye-slash' : '@phi.eye'"
              size="18px"
            ></gatewee-icon>
          </button>
        </div>

        <div class="gw-flex gw-items-start gw-gap-2">
          <input
            type="checkbox"
            class="gw-mt-1 gw-w-4 gw-h-4 gw-rounded gw-border-border-normal gw-text-text-action focus:gw-ring-text-action"
            id="acceptTerms"
            formControlName="acceptTerms"
          />
          <label
            for="acceptTerms"
            class="gw-text-sm gw-text-text-secondary gw-cursor-pointer"
          >
            {{ 'features.signup.form.acceptTerms' | translate }}
            <a
              [href]="assets?.termsOfService ?? 'javascript:void(0);'"
              target="_blank"
              rel="noopener noreferrer"
              class="gw-text-text-action hover:gw-underline"
              >{{ 'features.signup.form.termsLink' | translate }}</a
            >
          </label>
        </div>
        <small
          *ngIf="
            signupForm.get('acceptTerms')?.invalid &&
            signupForm.get('acceptTerms')?.touched
          "
          class="gw-text-status-negative"
        >
          {{ 'features.signup.form.errors.acceptTermsRequired' | translate }}
        </small>

        <gatewee-button
          variant="primary"
          [title]="'features.signup.form.submitButton' | translate"
          type="submit"
          class="gw-w-full"
          [disabled]="signupForm.invalid"
        ></gatewee-button>
      </form>
    </div>
  </div>

  <app-links></app-links>
</div>
